export const ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS = 'ADD_TEAM_FIELD_EXPENSE_BUCKETS_WITH_TAGS';
export const ADD_ACTIVE_EXPENSE_TAG_BUCKETS = 'ADD_ACTIVE_EXPENSE_TAG_BUCKETS';
// only buckets with "team_field" bucket type (should be not used and removed once we will switch to use paginated API)
export class AddActiveTeamFieldBucketsWithActiveTags {
    constructor(expenseBuckets) {
        this.type = ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS;
        this.payload = expenseBuckets;
    }
}
// all expense buckets for organization that are not disabled
export class AddActiveExpenseTagBuckets {
    constructor(expenseBuckets) {
        this.type = ADD_ACTIVE_EXPENSE_TAG_BUCKETS;
        this.payload = expenseBuckets;
    }
}
